import { useState } from "react";
import { OrderResponse, patchOrderBaristaByID } from "../../../../../api/order.api";
import CancelOrder from "../../../modal_page/cancelOrder";

type Props = { order: OrderResponse; reset: () => void };

function ButtonDone({ reset, order }: Props) {
  const [rejectID, setRejectID] = useState<number | null>(null);
  const [busy, setBusy] = useState(false);

  const closeModal = () => { setRejectID(null); reset(); };

  const handleDone = async () => {
    setBusy(true);
    try {
      // Skip the legacy "done → picked" wait — "Mark done" finalises the order
      // in one step. The server stamps both readyAt and pickedAt for stats.
      await patchOrderBaristaByID(order.id, { reject_note: "", status: "picked" });
      reset();
    } catch (err) {
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <CancelOrder reject={rejectID} onClose={closeModal} />
      <div className="flex gap-2 ml-auto">
        <button
          type="button"
          onClick={() => setRejectID(order.id)}
          disabled={busy}
          className="inline-flex items-center justify-center gap-2 h-[44px] px-6 text-sm font-semibold rounded-full bg-rose-50 text-rose-700 hover:bg-rose-100 active:scale-[0.97] transition disabled:opacity-40"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDone}
          disabled={busy}
          className="inline-flex items-center justify-center gap-2 h-[44px] px-6 text-sm font-bold rounded-full bg-emerald-600 text-white hover:bg-emerald-700 active:scale-[0.97] shadow-soft transition disabled:opacity-40"
        >
          {busy ? (
            <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity="0.25"/>
              <path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          ) : (
            <>
              Mark done
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/>
              </svg>
            </>
          )}
        </button>
      </div>
    </>
  );
}

export default ButtonDone;
